import { firestore } from "firebase";
import * as _ from 'underscore'
import Axios from 'axios'

export async function PromiseMap<T>(pmap: { [P in keyof T]: Promise<T[P]> }) {
  const r: any = {};
  await Promise.all(Object.keys(pmap).map(key => (async () => {
    r[key] = await pmap[<keyof T>key]
  })()))
  return <T>r
}


const atcoder_contest_head = "https://atcoder.jp/contests"

export type HornProblem = {
  id: string
  contest_id: string
  title: string
  url?: string
  touched_at?: Date
  tag: { [key:string]: HornProblemTag }
}
const colname_problem = "horn_problems"

export type HornContest = {
  id: string
  title: string
  start: Date
  duration_second?: number
  time_info: string
  ABC: boolean
  ARC: boolean
  AGC: boolean
  editoroial_url?: string
  url?: string
  problems?: HornProblem[]
  rate_change?: number
}
const colname_contest = "horn_contests"

export class Problem {
  static async fetch() {
    const res = await Axios.get(`https://horn.corvvs.dev/problems/${Date.now() % (86400*1000)}`)
    return (<any[]>res.data).map(r => {
      r.url = `${atcoder_contest_head}/${r.contest_id}/tasks/${r.id}`
      r.tag = r.tag || {}
      if (r.touched_at) {
        r.touched_at = new Date(r.touched_at._seconds*1000)
      }
      return <HornProblem>r
    })
  }

  static async set_tag(p: HornProblem) {
    p.touched_at = new Date()
    return firestore().collection(colname_problem).doc(p.id).update({ tag: p.tag || {}, touched_at: p.touched_at })
  }
}
export class Contest {
  static async fetch() {
    const res = await Axios.get(`https://horn.corvvs.dev/contests/${Date.now() % (86400*1000)}`)
    return (<any[]>res.data).map(r => {
      r.start = new Date(r.start_epoch_second*1000)
      r.url = `${atcoder_contest_head}/${r.id}`
      r.time_info = r.duration_second ? `${r.start.toLocaleString()} + ${r.duration_second/60}mins` : r.start.toLocaleString()
      const m = (r.rate_change || "").match(/\d+/)
      r.rate_change = m ? parseInt(m[0]) : undefined
      return <HornContest>r
    })
  }

  static async fetch_with_problems() {
    const { contests, problems } = await PromiseMap({
      contests: this.fetch(),
      problems: Problem.fetch(),
    })
    const ch: { [key:string]: HornContest } = {}
    contests.forEach(c => ch[c.id] = c)
    problems.forEach(p => {
      const c = ch[p.contest_id]
      if (!c) { return }
      c.problems = c.problems || []
      c.problems!.push(p)
    })
    return contests
  }
}

export type HornProblemTag = {
  name: string
}

export class Tag {
  static async fetch() {
    const h: { [key:string]: HornProblemTag[] } = {};
    (await firestore().collection("horn_tag").get()).docs.forEach(d => {
      const r: any = d.data()
      const { problem_id } = r
      h[problem_id] = h[problem_id] || []
      h[problem_id].push(<HornProblemTag>r)
    })
    return h
  }
}